module.exports = __webpack_public_path__ + "d6f4f82b.svg";